import { render } from "./SelectTheme.vue?vue&type=template&id=230e0ac7&scoped=true"
import script from "./SelectTheme.vue?vue&type=script&lang=js"
export * from "./SelectTheme.vue?vue&type=script&lang=js"

import "./SelectTheme.vue?vue&type=style&index=0&id=230e0ac7&scoped=true&language=scss&lang=css"
script.render = render
script.__scopeId = "data-v-230e0ac7"

export default script